// extracted by mini-css-extract-plugin
export default {"image":"GW-z","loaded":"HW-z"};